module.exports = __webpack_public_path__ + "img/amazon-small.2de08418.svg";